import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { Campaign, CreateCampaignRequest } from '@seo/types';
import { apiPost } from '@/lib/api';

export function useCreateCampaign() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateCampaignRequest) =>
      apiPost<Campaign>('/v1/campaigns', input, {
        headers: { 'idempotency-key': crypto.randomUUID() },
      }),
    onSuccess: (c) => {
      void qc.invalidateQueries({ queryKey: ['campaigns'] });
      qc.setQueryData(['campaign', c.id], c);
    },
  });
}
